<cs-popup #anchor class="md:w-[298px]" [position]="popupPosition()" [margin]="popupMargin()">
  <kendo-avatar
    csPopupAnchorContent
    shape="circle"
    [imageSrc]="user()?.picture!"
    class="size-8"
    data-testid="popup-anchor"></kendo-avatar>

  <div csPopupPanelContent>
    <cs-user-menu (logout)="handleLogout()" [user]="user()" (closeEvent)="close()"></cs-user-menu>
  </div>
</cs-popup>
